<template>
  <div>
    <div style="padding-top: 15px">
      <el-button type="primary" @click="addRankRewardRow()">新增</el-button>
      <el-button type="primary" @click="showBack()">返回</el-button>
    </div>
    <div class="common-table">
      <el-table v-loading="loading" :data="rankRewardList" height="80vh" row-key="id" min-height="50vh" ref="tableRef">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-table :data="props.row.rankRewards" height="100%">
              <el-table-column align="center" label="排名" prop="rank">
                <template slot-scope="scope">第 {{ scope.row.rank }} 名</template>
              </el-table-column>
              <el-table-column align="center" label="排名奖励(百分比)" prop="reward">
                <template slot-scope="scope">{{ scope.row.reward }}%</template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button type="primary" size="mini"
                    @click="showFormItem(props.row.rankRewards, scope.$index, scope.row, props.$index)">编辑</el-button>
                  <el-button type="danger" size="mini"
                    @click="deleteEditItem(scope.$index, props.row.rankRewards, props.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column align="center" label="ID" prop="id">
          <template slot-scope="scope">{{ scope.row.id }}</template>
        </el-table-column>
        <el-table-column align="center" label="名称" prop=" name">
          <template slot-scope="scope">{{ scope.row.name }}</template>
        </el-table-column>
        <el-table-column align="center" label="适用人数" prop="peopleApplicable">
          <template slot-scope="scope">{{ scope.row.peopleApplicable }}</template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="success" size="mini" @click="addRankRewardRow(scope.row)">编辑名称</el-button>
            <el-button type="primary" size="mini"
              @click="showFormItem(scope.row.rankRewards, (scope.row.rankRewards || []).length, { id: scope.row.id }, scope.$index)">新增排名奖励</el-button>
            <el-button type="danger" size="mini" @click="saveEdit(scope.$index)">保存奖励配置</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div v-show="showItemForm" class="common-popup-bg">
      <div class="common-popup" style="width: 400px">
        <h3>{{ "玩家奖励" }}</h3>
        <el-form ref="rewardMttRankEdt" size="medium" :model="currentItem" class="common-popup-table"
          label-width="90px">
          <el-form-item label="排名奖励:" prop="reward">
            <el-input type="number" resize="none" v-model="currentItem.rank" placeholder="排名" :min="1" :max="100" />
          </el-form-item>
          <el-form-item label="排名奖励:" prop="reward">
            <el-input type="number" resize="none" v-model="currentItem.reward" placeholder="排名奖励(百分比)" :min="0.01"
              :max="100" :step="0.1" />
          </el-form-item>
        </el-form>
        <footer>
          <el-button size="small" @click="showItemForm = false">取消</el-button>
          <el-button size="small" type="primary" @click="submitAddItem()">确定</el-button>
        </footer>
      </div>
    </div>
    <div v-show="showRowForm" class="common-popup-bg">
      <div class="common-popup" style="width: 600px">
        <h3>{{ "玩家奖励" }}</h3>
        <el-form ref="rewardMttEdt" size="medium" :model="currentRowInfo" class="common-popup-table"
          label-width="120px">
          <el-form-item label="排名奖励名称:" prop="reward">
            <el-input resize="none" v-model="currentRowInfo.name" placeholder="请输入排名奖励名称" />
          </el-form-item>
          <el-form-item label="适用人数:" prop="peopleApplicable">
            <div v-for="(people, index) in currentRowInfo.peopleApplicableList" :key="index"
              class="people-applicable-item">
              <el-input-number v-model="currentRowInfo.peopleApplicableList[index]" :min="2" :max="9" />
              &nbsp;&nbsp;
              <el-button size="mini" type="danger" @click="removePeopleApplicable(index)">删除</el-button>
              <br />
            </div>
            <el-button size="mini" type="primary" @click="addPeopleApplicable()">新增适用人数</el-button>
          </el-form-item>
        </el-form>
        <footer>
          <el-button size="small" @click="showRowForm = false">取消</el-button>
          <el-button size="small" type="primary" @click="submitAddRow()">确定</el-button>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
import { Decimal } from 'decimal.js';
import { mapActions, mapGetters, mapState } from "vuex";
import {
  MIN_PEOPLE_APPLICABLE,
  MAX_PEOPLE_APPLICABLE,
  parsePeopleApplicable,
  stringifyPeopleApplicable,
  hasDuplicatePeopleApplicable,
  isValidPeopleApplicable,
} from "./rankRewardPeopleApplicable";
export default {
  props: ["rewardList"],
  data() {
    return {
      id: null,
      showItemForm: false,
      showRowForm: false,
      loading: false,
      list: [],
      currentItem: {
        id: null, // 新增：1 编辑：2
        rank: 0,
        reward: 0,
      },
      currentList: null,
      currentIndex: 0,
      currentRow: 0,
      currentRowInfo: { name: '' },
      rules: {

      },
    };
  },
  computed: {
    ...mapState("login", ["permissions"]),
    ...mapGetters("rankReward", ["getRankReward"]),
    rankRewardList() {
      return this.list;
    },
  },
  created() {
    // this.getList();
  },
  methods: {
    ...mapActions("rankReward", [
      "getRankRewardList",
      "addRankReward",
      "updateRankReward",
      "deleteRankReward",
    ]),
    deleteEditItem(index, rankRewards, row) {
      rankRewards.splice(index, 1);
      this.$refs['tableRef'].toggleRowExpansion(row, false);
      const self = this;
      setTimeout(() => {
        self.$refs['tableRef'].toggleRowExpansion(row, true);
      }, 500)
    },
    addRankRewardRow(obj) {
      this.showRowForm = true;
      this.currentRowInfo = obj || {};
      const peopleApplicableList = parsePeopleApplicable(this.currentRowInfo.peopleApplicable);
      this.$set(
        this.currentRowInfo,
        "peopleApplicableList",
        peopleApplicableList.length ? peopleApplicableList : [MIN_PEOPLE_APPLICABLE]
      );
    },
    addPeopleApplicable() {
      const peopleApplicableList = this.currentRowInfo.peopleApplicableList || [];
      if (hasDuplicatePeopleApplicable(peopleApplicableList)) {
        this.$message.error("适用人数不能重复");
        return;
      }
      const nextPeople = this.getNextPeopleApplicable(peopleApplicableList);
      if (!nextPeople) {
        this.$message.error("适用人数只能在2到9之间，且不能重复");
        return;
      }
      peopleApplicableList.push(nextPeople);
      this.$set(this.currentRowInfo, "peopleApplicableList", peopleApplicableList);
    },
    removePeopleApplicable(index) {
      const peopleApplicableList = this.currentRowInfo.peopleApplicableList || [];
      if (peopleApplicableList.length <= 1) {
        this.$message.error("至少保留一个适用人数");
        return;
      }
      peopleApplicableList.splice(index, 1);
    },
    getNextPeopleApplicable(peopleApplicableList) {
      for (let people = MIN_PEOPLE_APPLICABLE; people <= MAX_PEOPLE_APPLICABLE; people++) {
        if (!parsePeopleApplicable(peopleApplicableList).includes(people)) {
          return people;
        }
      }
      return null;
    },
    arraySpanMethod({ row, columnIndex }) {
      if (columnIndex === 0) {
        return {
          rowspan: row.rowspan,
          colspan: row.colspan,
        };
      }
    },
    getList() {
      this.loading = true;
      this.getRankRewardList().then((res) => {
        this.loading = false;
        this.list = res.data;
        this.close(res);
      });
    },
    deleteEdit(id) {
      this.deleteRankReward(id).then(() => {
        this.$message.success("删除成功");
        this.getList();
      });
    },
    showFormItem(list, index, obj, row) {
      this.currentItem = obj;
      this.currentList = list;
      this.currentIndex = index;
      this.showItemForm = true;
      this.currentRow = row;
    },
    showBack() {
      this.list = [];
      this.$emit("editRewardList", false);
    },
    submitAddItem() {
      if (this.currentItem.rank) {
        this.currentItem.rank = parseInt(this.currentItem.rank)
      } else {
        this.$message.error("请输入排名");
        return;
      }
      if (this.currentItem.reward) {
        this.currentItem.reward = parseFloat(this.currentItem.reward)
      } else {
        this.$message.error("请输入排名奖励");
        return;
      }
      this.currentList[this.currentIndex] = this.currentItem;
      this.closeFormItem();
      this.$refs['tableRef'].toggleRowExpansion(this.list[this.currentRow], false);
      const self = this;
      setTimeout(() => {
        self.$refs['tableRef'].toggleRowExpansion(self.list[self.currentRow], true);
      }, 500)
    },
    submitAddRow() {
      if (!this.currentRowInfo.name) {
        this.$message.error("请输入排名奖励名称");
        return;
      }
      if (!isValidPeopleApplicable(this.currentRowInfo.peopleApplicableList)) {
        this.$message.error("适用人数只能在2到9之间");
        return;
      }
      if (hasDuplicatePeopleApplicable(this.currentRowInfo.peopleApplicableList)) {
        this.$message.error("适用人数不能重复");
        return;
      }
      this.currentRowInfo.peopleApplicable = stringifyPeopleApplicable(this.currentRowInfo.peopleApplicableList);
      if (!this.currentRowInfo.id) {
        const cri = { ...this.currentRowInfo };
        delete cri.peopleApplicableList;
        if (!cri.rankRewards || !cri.rankRewards.length) {
          cri.rankRewards = [];
        }
        this.list = [...this.list, { ...cri }]
      } else {
        delete this.currentRowInfo.peopleApplicableList;
      }
      this.showRowForm = false;
    },
    saveEdit(index) {
      const row = this.list[index];
      const rankRewards = row.rankRewards;
      if (!rankRewards || !rankRewards.length) {
        this.$message.error('请配置排名奖励');
        return;
      }
      const rm = {};
      for (let index = 0; index < rankRewards.length; index++) {
        const e = rankRewards[index];
        const v = rm[`${e.rank}`];
        if (!v) {
          rm[`${e.rank}`] = 1;
        } else {
          rm[`${e.rank}`] = v + 1;
        }
      }
      const entries = Object.entries(rm);
      // 判断排名是否重复
      for (let index = 0; index < entries.length; index++) {
        const element = entries[index];
        if (element[1] > 1) {
          this.$message.error(`排名奖励错误,重复的排名:${element[0]}`);
          return;
        }
      }
      // 判断排名是否断档
      const ranks = Object.keys(rm).map(s => parseInt(s));
      const max = Math.max(...ranks);
      for (let index = 1; index <= max; index++) {
        if (!rm[`${index}`]) {
          this.$message.error(`排名奖励错误,缺失排名:${index} `);
          return;
        }
      }
      let decimal = new Decimal(0);
      // 计算总的奖励为 100 
      const rewards = rankRewards.map(s => s.reward);
      for (let index = 0; index < rewards.length; index++) {
        const reward = rewards[index];
        decimal = decimal.plus(new Decimal(reward));
      }
      if (decimal.toString() != '100') {
        this.$message.error(`总奖励必须为 100%`);
        return;
      }
      if (row.id) {
        this.updateRankReward({ ...row }).then(res => {
          this.$message.success("更新配置成功!");
          this.getList();
        }).catch(e => {
          this.$message.error("更新配置失败!");
        })
      } else {
        this.addRankReward({ ...row }).then(res => {
          this.$message.success("新增配置成功!");
        }).catch(e => {
          this.$message.error("新增配置失败!");
        })
      }

    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let { ...params } = this.form;
          if (this.id == null) {
            params.reward = params.reward * 100;
            this.addRankReward(params).then(() => {
              this.$message.success("添加成功");
              this.getList();
              this.close(formName);
            });
          } else if (this.id != null) {
            params.reward = params.reward * 100;
            this.updateRankReward(params).then(() => {
              this.$message.success("修改成功");
              this.getList();
              this.close(formName);
            });
          }
        }
      });
    },
    close() { },
    closeFormItem() {
      this.showItemForm = false;
    },
  },
};
</script>
